import { TrashIcon } from "@radix-ui/react-icons";
import { Flex, IconButton, Text } from "@radix-ui/themes";
import dayjs from "dayjs";
import { twMerge } from "tailwind-merge";

interface JourneyAnnotationItemProps {
  title: string;
  selectedEventId: string;
  timestamp: Date;
  isSelected: boolean;
  isEditable: boolean;
  onSelect: () => void;
  onDelete: (mouseEvent: React.MouseEvent) => void;
}

const JourneyAnnotationItem = ({
  isSelected,
  title,
  timestamp,
  isEditable,
  onSelect,
  onDelete,
}: JourneyAnnotationItemProps) => {
  return (
    <Flex
      justify="between"
      align="center"
      maxWidth="100%"
      className={twMerge([
        "p-2 hover:bg-neutral-200",
        isSelected && "bg-neutral-200 hover:bg-neutral-200",
      ])}
      onClick={() => onSelect()}
    >
      <Text
        size="1"
        className="truncate w-3/4 overflow-hidden text-ellipsis whitespace-nowrap"
      >
        {title}
      </Text>
      <Flex gap="2" align="center">
        <Text size="1" className="w-20" align="right">
          {dayjs(timestamp).utc().format("HH:mm:ss.SSS")}
        </Text>
        {isEditable && (
          <IconButton
            size="1"
            color="gray"
            variant="soft"
            onClick={(mouseEvent) => onDelete(mouseEvent)}
          >
            <TrashIcon />
          </IconButton>
        )}
      </Flex>
    </Flex>
  );
};

export default JourneyAnnotationItem;
